import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiArrowRight, FiAward, FiUsers, FiTrendingUp } from 'react-icons/fi';
import './AboutSection.css';

const AboutSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: FiAward,
      title: t('about.features.quality.title'),
      description: t('about.features.quality.description')
    },
    {
      icon: FiUsers,
      title: t('about.features.team.title'),
      description: t('about.features.team.description')
    },
    {
      icon: FiTrendingUp,
      title: t('about.features.results.title'),
      description: t('about.features.results.description')
    }
  ];

  return (
    <section id="about" className="about-section section-padding">
      <div className="about-shape about-shape-1" />
      <div className="about-shape about-shape-2" />

      <div className="container">
        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <span className="section-badge">
              {t('about.buildingExcellence')}
            </span>
            <h2 className="section-title">{t('about.title')}</h2>
            <h3 className="section-subtitle">{t('about.subtitle')}</h3>
            <p className="about-description">
              {t('about.description')}
            </p>

            <div className="about-stats">
              <div className="stat-box">
                <div className="stat-number">15+</div>
                <div className="stat-text">{t('about.experience')}</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">200+</div>
                <div className="stat-text">{t('about.projects')}</div>
              </div>
              <div className="stat-box">
                <div className="stat-number">150+</div>
                <div className="stat-text">{t('about.clients')}</div>
              </div>
            </div>

            <div className="about-cta">
              <Link to={{ pathname: '/', hash: '#investment' }} className="btn btn-primary">
                {t('about.learnMore')}
                <FiArrowRight />
              </Link>
              <p>{t('about.missionText')}</p>
            </div>
          </motion.div>

          <motion.div
            className="about-features"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            {features.map((feature, index) => (
              <motion.div
                key={index}
                className="feature-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
              >
                <div className="feature-header">
                  <div className="feature-index">0{index + 1}</div>
                  <div className="feature-icon">
                    <feature.icon />
                  </div>
                </div>
                <div className="feature-body">
                  <h4 className="feature-title">{feature.title}</h4>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
